import { BiHome } from "react-icons/bi";
import Img404 from "../../../assets/img/404img.png";
import Button from "../../../components/button/button";
import "./error404.scss";

export default function Error404() {
    return (
        <div className="error-page">
            <img src={Img404} className="error-page__img" alt="" />
            <h1 className="error-page__title">404 - Página no encontrada</h1>
            <p className="error-page__message">
                Vaya, parece que la página no existe, pero puedo llevarte de
                vuelta al inicio.
            </p>
            <Button
                label="Volver al inicio"
                path="/"
                variant="filled"
                icon={<BiHome />}
            />
        </div>
    );
}
